import { mapActions } from 'vuex';

export default {
  name: 'SnackbarMixin',
  methods: {
    ...mapActions('app', ['showSuccessSnackbar', 'showErrorSnackbar', 'showInfoSnackbar']),
    showSuccessMessage(text) {
      this.showSuccessSnackbar(text);
    },
    showErrorMessage(text) {
      this.showErrorSnackbar(text);
    },
    showInfoMessage(text) {
      this.showInfoSnackbar(text);
    },
  },
};
